import { createSlice } from '@reduxjs/toolkit'

export interface IContractHistoryState {
  entries: any[]
}

const initialState: IContractHistoryState = {
  entries: []
}

export const contractHistorySlice = createSlice({
  name: 'contract history',
  initialState,
  reducers: {
    setHistory: (state, action) => {
      state.entries = action.payload.entries.reverse()
    },
    clearContractHistory: (state) => {
      state.entries = []
    }
  }
})

export const { setHistory, clearContractHistory } = contractHistorySlice.actions
export default contractHistorySlice.reducer
